import { FC, ReactNode } from 'react';


import {
  AppProvider,
  Card,
  SkeletonBodyText,
  Spinner,
  Tabs,
  SkeletonPage,
  Page,
  Layout,
  TextContainer,
  SkeletonDisplayText,
 } from '@shopify/polaris';


 const Word = ({ width }: { width: number | string }) => <div style={{ width }}><SkeletonBodyText lines={1} /></div>

 const CardSpinner = () => <div className="AC-Tabbed-Card__Loader-Wrap"><Spinner size="large" /></div>

 type SkeletonComponent = FC<{ children?: ReactNode }> & { Article: FC };

 const Skeleton = ((_props: { children?: ReactNode }) => {
   return (
     <AppProvider i18n={{}}>
      <div className="AC-Skeleton_Fullwidth-Page">
        <SkeletonPage>
          <Card>
            <Tabs tabs={[{ id: '0', content: <Word width={120} /> }, { id: '1', content: <Word width={120} /> }] as any} selected={0}></Tabs>
            <CardSpinner/>
          </Card>
        </SkeletonPage>
      </div>
    </AppProvider>
  )
}) as SkeletonComponent


Skeleton.Article = () => {
  return (
    <AppProvider i18n={{}}>
      <Page>
      {/* <Loading/> */}
        <Layout>
          <Layout.Section>
             <TextContainer>
              <SkeletonDisplayText size="extraLarge" />
              <div style={{marginTop: '3.5rem'}}>
                <SkeletonBodyText lines={9} />
              </div>
            </TextContainer>
          </Layout.Section>
        </Layout>
      </Page>
    </AppProvider>
  )
}

export default Skeleton
